const initialstate = {
  data:[],
  dataview:[],
  
}

const OrgNeedsReducers =  (state = initialstate, action:any)=>{
  switch (action.type){
      case 'fetch_data_success':
          return {... state, data:action.payload};
          case 'fetch_needview_data_success':
        return{ ...state, dataview: action.payload }
                     default :
          return state;
  }
};
export default OrgNeedsReducers;